import React from "react";
import styled from "styled-components";
import { fonts } from "../../../../../../theme/fonts";

export const Countdown = ({ label, days, hours, minutes, seconds }) => {
  return (
    <>
      <CountdownContainer xCenter>
        <CountdownTitle>{label}</CountdownTitle>
        <Row>
          {days >= 1 && (
            <IncrementBox>
              <Outline xCenter>
                <Increment>{days}</Increment>
              </Outline>
              <Label>Día{days !== 1 ? "s" : ""}</Label>
            </IncrementBox>
          )}

          <IncrementBox>
            <Outline xCenter>
              <Increment>{hours}</Increment>
            </Outline>
            <Label>Hora{hours !== 1 ? "s" : ""}</Label>
          </IncrementBox>

          <IncrementBox>
            <Outline xCenter>
              <Increment>{minutes}</Increment>
            </Outline>
            <Label>Minuto{minutes !== 1 ? "s" : ""}</Label>
          </IncrementBox>

          {days < 1 && (
            <IncrementBox>
              <Outline xCenter>
                <Increment>{seconds}</Increment>
              </Outline>
              <Label>Segundo{seconds !== 1 ? "s" : ""}</Label>
            </IncrementBox>
          )}
        </Row>
      </CountdownContainer>
    </>
  );
};

const CountdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

const CountdownTitle = styled.h3`
  color: #4580dd;
  font-size: 26px;
  font-family: ${fonts.brandBold};
  margin-bottom: 20px;
  text-transform: uppercase;
`;

const Increment = styled.p`
  color: #0678bc;
  font-size: 50px;
  font-family: ${fonts.brandBold};
  margin: 16px 0;
`;

const Label = styled.div`
  color: #a7a7a7;
  text-transform: uppercase;
  font-family: ${fonts.brandBold};
`;

const IncrementBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 33%;
  justify-content: space-between;
  padding: 14px 0;

  & + & {
    margin-left: 9px;
  }

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    & + & {
      margin-left: 24px;
    }
  }
`;

const Outline = styled.div`
  border: 1px solid #d6d6d6;
  flex-direction: column;
  display: flex;
  margin-bottom: 10px;
  align-items: center;
  justify-content: center;
`;
